import { Pipe } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormatDateTimePipe } from '../generic';

/**
 * Picks up the creationTime and modificationTime from the domain objects
 * and outputs a SafeHtml entry to show these.
 *
 * If modification time is null then the creation time is shown for this.
 */
@Pipe({
    name: 'formatCreationModificationTime',
    pure: true
})
export class FormatCreationModificationTimePipe {
    constructor(
        private formatDateTimePipe: FormatDateTimePipe,
        private domSanitizer: DomSanitizer
    ) {}

    /**
     *
     * @param timestamps the timestamps to format
     * @param showCreation should the creation time be shown separately
     * @param showModification should the modification time be shown, or what label should be used to show it
     * @returns
     */
    transform(
        timestamps: { creationTime?: string; modificationTime?: string },
        showCreation = true,
        showModification: boolean | string = true
    ): SafeHtml | string {
        if (timestamps == null) {
            return '';
        }

        let ret = '';
        if (timestamps.creationTime != null && showCreation) {
            ret += `<b>Creation:</b>&nbsp;${this.formatDateTimePipe.transform(
                timestamps.creationTime
            )} `;
        }
        if (
            (timestamps.modificationTime != null ||
                timestamps.creationTime != null) &&
            showModification
        ) {
            const modificationLabel =
                typeof showModification === 'string'
                    ? showModification
                    : 'Modification';
            ret += `<b>${modificationLabel}:</b>&nbsp;${this.formatDateTimePipe.transform(
                timestamps.modificationTime ?? timestamps.creationTime!
            )} `;
        }
        return this.domSanitizer.bypassSecurityTrustHtml(ret);
    }
}
